import { createApiClient } from "@ametie/vue-muza-use";

import { authSession, INSIGHTS_API_BASE_URL } from "./authSession";

export const myAxios = createApiClient({
  baseURL: INSIGHTS_API_BASE_URL,
  timeout: 2 * 60 * 1000, // 2 minutes timeout
  authSession,
});
